import './css/styles.scss';

function InitBlock() {}

InitBlock();
